// IAM-04: the backend refuses admin actions from a session that has not passed
// MFA when the tenant's `mfa_admin` policy is on, with one of two codes.
export const MFA_ENROLL_PATH = '/settings?tab=account-setup&asec=security';

export type MfaRequirement =
  | { kind: 'enroll'; message: string; redirect: string }
  | { kind: 'step_up'; message: string; permission?: string };

export function mfaRequirement(detail: unknown): MfaRequirement | null {
  if (!detail || typeof detail !== 'object') return null;
  const d = detail as { code?: string; message?: string; permission?: string };
  if (d.code === 'mfa_enrollment_required') {
    return {
      kind: 'enroll',
      message: d.message || 'Set up two-factor authentication to perform admin actions.',
      redirect: MFA_ENROLL_PATH,
    };
  }
  if (d.code === 'step_up_required') {
    return {
      kind: 'step_up',
      message: d.message || 'Verify with your second factor to continue.',
      permission: d.permission,
    };
  }
  return null;
}
